import gql from 'graphql-tag';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AuthAndClient = {
  client?: Maybe<Client>;
  authentication_type?: Maybe<AuthenticationType>;
  existing_user: Scalars['Boolean'];
};

export enum AuthenticationType {
  Auth = 'auth',
  Sso = 'sso',
}

export type Client = {
  id: Scalars['ID'];
  title: Scalars['String'];
  subdomain?: Maybe<Scalars['String']>;
  email_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  content_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  client_status: ClientStatus;
  authentication_type: AuthenticationType;
  sso_configuration?: Maybe<SsoConfiguration>;
  allow_user_signup: Scalars['Boolean'];
  departments_in_signup: Scalars['Boolean'];
  departments_in_signup_required: Scalars['Boolean'];
  locations_in_signup: Scalars['Boolean'];
  locations_in_signup_required: Scalars['Boolean'];
  support_multiple_languages: Scalars['Boolean'];
  allow_user_invites: Scalars['Boolean'];
  default_timezone?: Maybe<Scalars['String']>;
  default_language?: Maybe<Scalars['String']>;
  image?: Maybe<S3Object>;
};

export type ClientInvitation = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  email_address: Scalars['String'];
  invitation_status: ClientInvitationStatus;
  subject?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  email_from_address?: Maybe<Scalars['String']>;
  created_at: Scalars['Int'];
  updated_at: Scalars['Int'];
  last_sent_at?: Maybe<Scalars['Int']>;
  retries?: Maybe<Scalars['Int']>;
  accepted_at?: Maybe<Scalars['Int']>;
  accepted_by_user_id?: Maybe<Scalars['ID']>;
};

/** Client invitations */
export enum ClientInvitationStatus {
  Active = 'active',
  Deleted = 'deleted',
  Accepted = 'accepted',
}

export type ClientRequest = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  email_address: Scalars['String'];
  request_status: ClientRequestStatus;
  created_at: Scalars['Int'];
  updated_at: Scalars['Int'];
};

/** Client requests */
export enum ClientRequestStatus {
  Active = 'active',
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export enum ClientStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export type CreateClientRequestInput = {
  client_id: Scalars['ID'];
  email_address: Scalars['String'];
};

export type Mutation = {
  /** Create a client request */
  createClientRequest: ClientRequest;
};

export type MutationCreateClientRequestArgs = {
  data: CreateClientRequestInput;
};

export type Query = {
  getAuthAndClient: AuthAndClient;
  /** Get active client by attr */
  getActiveClientByAttr?: Maybe<Client>;
  /** Get a client object */
  getClientByEmailDomain?: Maybe<Client>;
  /** Get a client invitation */
  getClientInvitation?: Maybe<ClientInvitation>;
};

export type QueryGetAuthAndClientArgs = {
  email_address: Scalars['String'];
};

export type QueryGetActiveClientByAttrArgs = {
  key: UniqueClientKey;
  value: Scalars['String'];
};

export type QueryGetClientByEmailDomainArgs = {
  email_domain: Scalars['String'];
};

export type QueryGetClientInvitationArgs = {
  id: Scalars['ID'];
};

/** Images */
export type S3Object = {
  bucket: Scalars['String'];
  key: Scalars['String'];
  region: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type SsoConfiguration = {
  metadata?: Maybe<Scalars['String']>;
  metadata_url?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
};

/** Clients */
export enum UniqueClientKey {
  Subdomain = 'subdomain',
  Id = 'id',
  EmailDomain = 'email_domain',
}

export type ClientCommonFragment = Pick<
  Client,
  | 'id'
  | 'title'
  | 'subdomain'
  | 'email_domains'
  | 'content_domains'
  | 'client_status'
  | 'authentication_type'
  | 'allow_user_signup'
  | 'departments_in_signup'
  | 'departments_in_signup_required'
  | 'locations_in_signup'
  | 'locations_in_signup_required'
  | 'default_timezone'
  | 'default_language'
  | 'support_multiple_languages'
> & {
  sso_configuration: Maybe<Pick<SsoConfiguration, 'provider'>>;
  image: Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height' | 'region'>>;
};

export type ClientPublicFragment = ClientCommonFragment;

export type GetActiveClientByAttrQueryVariables = {
  key: UniqueClientKey;
  value: Scalars['String'];
};

export type GetActiveClientByAttrQuery = { getActiveClientByAttr: Maybe<ClientPublicFragment> };

export type GetAuthAndClientQueryVariables = {
  email_address: Scalars['String'];
};

export type GetAuthAndClientQuery = {
  getAuthAndClient: Pick<AuthAndClient, 'existing_user' | 'authentication_type'> & {
    client: Maybe<ClientPublicFragment>;
  };
};

export type GetClientInvitationQueryVariables = {
  id: Scalars['ID'];
};

export type GetClientInvitationQuery = {
  getClientInvitation: Maybe<
    Pick<ClientInvitation, 'id' | 'client_id' | 'email_address' | 'invitation_status'>
  >;
};

export const ClientCommonFragmentDoc = gql`
  fragment ClientCommon on Client {
    id
    title
    subdomain
    email_domains
    content_domains
    client_status
    authentication_type
    allow_user_signup
    departments_in_signup
    departments_in_signup_required
    locations_in_signup
    locations_in_signup_required
    default_timezone
    default_language
    support_multiple_languages
    sso_configuration {
      provider
    }
    image {
      bucket
      key
      width
      height
      region
    }
  }
`;
export const ClientPublicFragmentDoc = gql`
  fragment ClientPublic on Client {
    ...ClientCommon
  }
  ${ClientCommonFragmentDoc}
`;
export const GetActiveClientByAttrDocument = gql`
  query GET_ACTIVE_CLIENT_BY_ATTR($key: UniqueClientKey!, $value: String!) {
    getActiveClientByAttr(key: $key, value: $value) {
      ...ClientPublic
    }
  }
  ${ClientPublicFragmentDoc}
`;
export type GetActiveClientByAttrComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetActiveClientByAttrQuery,
    GetActiveClientByAttrQueryVariables
  >,
  'query'
> &
  ({ variables: GetActiveClientByAttrQueryVariables; skip?: boolean } | { skip: boolean });

export const GetActiveClientByAttrComponent = (props: GetActiveClientByAttrComponentProps) => (
  <ApolloReactComponents.Query<GetActiveClientByAttrQuery, GetActiveClientByAttrQueryVariables>
    query={GetActiveClientByAttrDocument}
    {...props}
  />
);

export type GetActiveClientByAttrProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetActiveClientByAttrQuery,
  GetActiveClientByAttrQueryVariables
> &
  TChildProps;
export function withGetActiveClientByAttr<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetActiveClientByAttrQuery,
    GetActiveClientByAttrQueryVariables,
    GetActiveClientByAttrProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetActiveClientByAttrQuery,
    GetActiveClientByAttrQueryVariables,
    GetActiveClientByAttrProps<TChildProps>
  >(GetActiveClientByAttrDocument, {
    alias: 'getActiveClientByAttr',
    ...operationOptions,
  });
}

/**
 * __useGetActiveClientByAttrQuery__
 *
 * To run a query within a React component, call `useGetActiveClientByAttrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveClientByAttrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveClientByAttrQuery({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useGetActiveClientByAttrQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetActiveClientByAttrQuery,
    GetActiveClientByAttrQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetActiveClientByAttrQuery, GetActiveClientByAttrQueryVariables>(
    GetActiveClientByAttrDocument,
    baseOptions,
  );
}
export function useGetActiveClientByAttrLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetActiveClientByAttrQuery,
    GetActiveClientByAttrQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetActiveClientByAttrQuery,
    GetActiveClientByAttrQueryVariables
  >(GetActiveClientByAttrDocument, baseOptions);
}
export type GetActiveClientByAttrQueryHookResult = ReturnType<typeof useGetActiveClientByAttrQuery>;
export type GetActiveClientByAttrLazyQueryHookResult = ReturnType<
  typeof useGetActiveClientByAttrLazyQuery
>;
export type GetActiveClientByAttrQueryResult = ApolloReactCommon.QueryResult<
  GetActiveClientByAttrQuery,
  GetActiveClientByAttrQueryVariables
>;
export const GetAuthAndClientDocument = gql`
  query GET_AUTH_AND_CLIENT($email_address: String!) {
    getAuthAndClient(email_address: $email_address) {
      existing_user
      authentication_type
      client {
        ...ClientPublic
      }
    }
  }
  ${ClientPublicFragmentDoc}
`;
export type GetAuthAndClientComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAuthAndClientQuery,
    GetAuthAndClientQueryVariables
  >,
  'query'
> &
  ({ variables: GetAuthAndClientQueryVariables; skip?: boolean } | { skip: boolean });

export const GetAuthAndClientComponent = (props: GetAuthAndClientComponentProps) => (
  <ApolloReactComponents.Query<GetAuthAndClientQuery, GetAuthAndClientQueryVariables>
    query={GetAuthAndClientDocument}
    {...props}
  />
);

export type GetAuthAndClientProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetAuthAndClientQuery,
  GetAuthAndClientQueryVariables
> &
  TChildProps;
export function withGetAuthAndClient<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetAuthAndClientQuery,
    GetAuthAndClientQueryVariables,
    GetAuthAndClientProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetAuthAndClientQuery,
    GetAuthAndClientQueryVariables,
    GetAuthAndClientProps<TChildProps>
  >(GetAuthAndClientDocument, {
    alias: 'getAuthAndClient',
    ...operationOptions,
  });
}

/**
 * __useGetAuthAndClientQuery__
 *
 * To run a query within a React component, call `useGetAuthAndClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthAndClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthAndClientQuery({
 *   variables: {
 *      email_address: // value for 'email_address'
 *   },
 * });
 */
export function useGetAuthAndClientQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAuthAndClientQuery,
    GetAuthAndClientQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetAuthAndClientQuery, GetAuthAndClientQueryVariables>(
    GetAuthAndClientDocument,
    baseOptions,
  );
}
export function useGetAuthAndClientLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAuthAndClientQuery,
    GetAuthAndClientQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetAuthAndClientQuery, GetAuthAndClientQueryVariables>(
    GetAuthAndClientDocument,
    baseOptions,
  );
}
export type GetAuthAndClientQueryHookResult = ReturnType<typeof useGetAuthAndClientQuery>;
export type GetAuthAndClientLazyQueryHookResult = ReturnType<typeof useGetAuthAndClientLazyQuery>;
export type GetAuthAndClientQueryResult = ApolloReactCommon.QueryResult<
  GetAuthAndClientQuery,
  GetAuthAndClientQueryVariables
>;
export const GetClientInvitationDocument = gql`
  query GET_CLIENT_INVITATION($id: ID!) {
    getClientInvitation(id: $id) {
      id
      client_id
      email_address
      invitation_status
    }
  }
`;
export type GetClientInvitationComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetClientInvitationQuery,
    GetClientInvitationQueryVariables
  >,
  'query'
> &
  ({ variables: GetClientInvitationQueryVariables; skip?: boolean } | { skip: boolean });

export const GetClientInvitationComponent = (props: GetClientInvitationComponentProps) => (
  <ApolloReactComponents.Query<GetClientInvitationQuery, GetClientInvitationQueryVariables>
    query={GetClientInvitationDocument}
    {...props}
  />
);

export type GetClientInvitationProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetClientInvitationQuery,
  GetClientInvitationQueryVariables
> &
  TChildProps;
export function withGetClientInvitation<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetClientInvitationQuery,
    GetClientInvitationQueryVariables,
    GetClientInvitationProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetClientInvitationQuery,
    GetClientInvitationQueryVariables,
    GetClientInvitationProps<TChildProps>
  >(GetClientInvitationDocument, {
    alias: 'getClientInvitation',
    ...operationOptions,
  });
}

/**
 * __useGetClientInvitationQuery__
 *
 * To run a query within a React component, call `useGetClientInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientInvitationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientInvitationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetClientInvitationQuery,
    GetClientInvitationQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetClientInvitationQuery, GetClientInvitationQueryVariables>(
    GetClientInvitationDocument,
    baseOptions,
  );
}
export function useGetClientInvitationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetClientInvitationQuery,
    GetClientInvitationQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetClientInvitationQuery, GetClientInvitationQueryVariables>(
    GetClientInvitationDocument,
    baseOptions,
  );
}
export type GetClientInvitationQueryHookResult = ReturnType<typeof useGetClientInvitationQuery>;
export type GetClientInvitationLazyQueryHookResult = ReturnType<
  typeof useGetClientInvitationLazyQuery
>;
export type GetClientInvitationQueryResult = ApolloReactCommon.QueryResult<
  GetClientInvitationQuery,
  GetClientInvitationQueryVariables
>;
